'use strict';

var _regeneratorRuntime = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _objectSpread = require("/buildkite/builds/ip-10-0-0-14-ap-southeast-2-compute-internal-1/volaby-australia/volaby-frontend/client.campfire/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

let _require = require('./symbols'),
    isClean = _require.isClean,
    my = _require.my;

let MapGenerator = require('./map-generator');

let stringify = require('./stringify');

let Container = require('./container');

let Document = require('./document');

let warnOnce = require('./warn-once');

let Result = require('./result');

let parse = require('./parse');

let Root = require('./root');

const TYPE_TO_CLASS_NAME = {
  document: 'Document',
  root: 'Root',
  atrule: 'AtRule',
  rule: 'Rule',
  decl: 'Declaration',
  comment: 'Comment'
};
const PLUGIN_PROPS = {
  postcssPlugin: true,
  prepare: true,
  Once: true,
  Document: true,
  Root: true,
  Declaration: true,
  Rule: true,
  AtRule: true,
  Comment: true,
  DeclarationExit: true,
  RuleExit: true,
  AtRuleExit: true,
  CommentExit: true,
  RootExit: true,
  DocumentExit: true,
  OnceExit: true
};
const NOT_VISITORS = {
  postcssPlugin: true,
  prepare: true,
  Once: true
};
const CHILDREN = 0;

function isPromise(obj) {
  return typeof obj === 'object' && typeof obj.then === 'function';
}

function getEvents(node) {
  let key = false;
  let type = TYPE_TO_CLASS_NAME[node.type];

  if (node.type === 'decl') {
    key = node.prop.toLowerCase();
  } else if (node.type === 'atrule') {
    key = node.name.toLowerCase();
  }

  if (key && node.append) {
    return [type, type + '-' + key, CHILDREN, type + 'Exit', type + 'Exit-' + key];
  } else if (key) {
    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key];
  } else if (node.append) {
    return [type, CHILDREN, type + 'Exit'];
  } else {
    return [type, type + 'Exit'];
  }
}

function toStack(node) {
  let events;

  if (node.type === 'document') {
    events = ['Document', CHILDREN, 'DocumentExit'];
  } else if (node.type === 'root') {
    events = ['Root', CHILDREN, 'RootExit'];
  } else {
    events = getEvents(node);
  }

  return {
    node,
    events,
    eventIndex: 0,
    visitors: [],
    visitorIndex: 0,
    iterator: 0
  };
}

function cleanMarks(node) {
  node[isClean] = false;
  if (node.nodes) node.nodes.forEach(i => cleanMarks(i));
  return node;
}

let postcss = {};

class LazyResult {
  constructor(processor, css, opts) {
    this.stringified = false;
    this.processed = false;
    let root;

    if (typeof css === 'object' && css !== null && (css.type === 'root' || css.type === 'document')) {
      root = cleanMarks(css);
    } else if (css instanceof LazyResult || css instanceof Result) {
      root = cleanMarks(css.root);

      if (css.map) {
        if (typeof opts.map === 'undefined') opts.map = {};
        if (!opts.map.inline) opts.map.inline = false;
        opts.map.prev = css.map;
      }
    } else {
      let parser = parse;
      if (opts.syntax) parser = opts.syntax.parse;
      if (opts.parser) parser = opts.parser;
      if (parser.parse) parser = parser.parse;

      try {
        root = parser(css, opts);
      } catch (error) {
        this.processed = true;
        this.error = error;
      }

      if (root && !root[my]) {
        /* c8 ignore next 2 */
        Container.rebuild(root);
      }
    }

    this.result = new Result(processor, root, opts);
    this.helpers = _objectSpread(_objectSpread({}, postcss), {}, {
      result: this.result,
      postcss
    });
    this.plugins = this.processor.plugins.map(plugin => {
      if (typeof plugin === 'object' && plugin.prepare) {
        return _objectSpread(_objectSpread({}, plugin), plugin.prepare(this.result));
      } else {
        return plugin;
      }
    });
  }

  get [Symbol.toStringTag]() {
    return 'LazyResult';
  }

  get processor() {
    return this.result.processor;
  }

  get opts() {
    return this.result.opts;
  }

  get css() {
    return this.stringify().css;
  }

  get content() {
    return this.stringify().content;
  }

  get map() {
    return this.stringify().map;
  }

  get root() {
    return this.sync().root;
  }

  get messages() {
    return this.sync().messages;
  }

  warnings() {
    return this.sync().warnings();
  }

  toString() {
    return this.css;
  }

  then(onFulfilled, onRejected) {
    if (process.env.NODE_ENV !== 'production') {
      if (!('from' in this.opts)) {
        warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
      }
    }

    return this.async().then(onFulfilled, onRejected);
  }

  catch(onRejected) {
    return this.async().catch(onRejected);
  }

  finally(onFinally) {
    return this.async().then(onFinally, onFinally);
  }

  async() {
    if (this.error) return Promise.reject(this.error);
    if (this.processed) return Promise.resolve(this.result);

    if (!this.processing) {
      this.processing = this.runAsync();
    }

    return this.processing;
  }

  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    this.processed = true;

    if (this.processing) {
      throw this.getAsyncError();
    }

    var _iterator = _createForOfIteratorHelper(this.plugins),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let plugin = _step.value;
        let promise = this.runOnRoot(plugin);

        if (isPromise(promise)) {
          throw this.getAsyncError();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    this.prepareVisitors();

    if (this.hasListener) {
      let root = this.result.root;

      while (!root[isClean]) {
        root[isClean] = true;
        this.walkSync(root);
      }

      if (this.listeners.OnceExit) {
        if (root.type === 'document') {
          var _iterator2 = _createForOfIteratorHelper(root.nodes),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              let subRoot = _step2.value;
              this.visitSync(this.listeners.OnceExit, subRoot);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          this.visitSync(this.listeners.OnceExit, root);
        }
      }
    }

    return this.result;
  }

  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = true;
    this.sync();
    let opts = this.result.opts;
    let str = stringify;
    if (opts.syntax) str = opts.syntax.stringify;
    if (opts.stringifier) str = opts.stringifier;
    if (str.stringify) str = str.stringify;
    let map = new MapGenerator(str, this.result.root, this.result.opts);
    let data = map.generate();
    this.result.css = data[0];
    this.result.map = data[1];
    return this.result;
  }

  walkSync(node) {
    node[isClean] = true;
    let events = getEvents(node);

    var _iterator3 = _createForOfIteratorHelper(events),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        let event = _step3.value;

        if (event === CHILDREN) {
          if (node.nodes) {
            node.each(child => {
              if (!child[isClean]) this.walkSync(child);
            });
          }
        } else {
          let visitors = this.listeners[event];

          if (visitors) {
            if (this.visitSync(visitors, node.toProxy())) return;
          }
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  visitSync(visitors, node) {
    var _iterator4 = _createForOfIteratorHelper(visitors),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        let _step4$value = _slicedToArray(_step4.value, 2),
            plugin = _step4$value[0],
            visitor = _step4$value[1];

        this.result.lastPlugin = plugin;
        let promise;

        try {
          promise = visitor(node, this.helpers);
        } catch (e) {
          throw this.handleError(e, node.proxyOf);
        }

        if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
          return true;
        }

        if (isPromise(promise)) {
          throw this.getAsyncError();
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  runOnRoot(plugin) {
    this.result.lastPlugin = plugin;

    try {
      if (typeof plugin === 'object' && plugin.Once) {
        if (this.result.root.type === 'document') {
          let roots = this.result.root.nodes.map(root => plugin.Once(root, this.helpers));

          if (isPromise(roots[0])) {
            return Promise.all(roots);
          }

          return roots;
        }

        return plugin.Once(this.result.root, this.helpers);
      } else if (typeof plugin === 'function') {
        return plugin(this.result.root, this.result);
      }
    } catch (error) {
      throw this.handleError(error);
    }
  }

  getAsyncError() {
    throw new Error('Use process(css).then(cb) to work with async plugins');
  }

  handleError(error, node) {
    let plugin = this.result.lastPlugin;

    try {
      if (node) node.addToError(error);
      this.error = error;

      if (error.name === 'CssSyntaxError' && !error.plugin) {
        error.plugin = plugin.postcssPlugin;
        error.setMessage();
      } else if (plugin.postcssVersion) {
        if (process.env.NODE_ENV !== 'production') {
          let pluginName = plugin.postcssPlugin;
          let pluginVer = plugin.postcssVersion;
          let runtimeVer = this.result.processor.version;
          let a = pluginVer.split('.');
          let b = runtimeVer.split('.');

          if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
            // eslint-disable-next-line no-console
            console.error('Unknown error from PostCSS plugin. Your current PostCSS ' + 'version is ' + runtimeVer + ', but ' + pluginName + ' uses ' + pluginVer + '. Perhaps this is the source of the error below.');
          }
        }
      }
    } catch (err) {
      /* c8 ignore next 3 */
      // eslint-disable-next-line no-console
      if (console && console.error) console.error(err);
    }

    return error;
  }

  runAsync() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var i, plugin, promise, root, stack, node, _iterator5, _step5, _step5$value, visitor, roots;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.plugin = 0;
            i = 0;

          case 2:
            if (!(i < _this.plugins.length)) {
              _context.next = 17;
              break;
            }

            plugin = _this.plugins[i];
            promise = _this.runOnRoot(plugin);

            if (!isPromise(promise)) {
              _context.next = 14;
              break;
            }

            _context.prev = 6;
            _context.next = 9;
            return promise;

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](6);
            throw _this.handleError(_context.t0);

          case 14:
            i++;
            _context.next = 2;
            break;

          case 17:
            _this.prepareVisitors();

            if (!_this.hasListener) {
              _context.next = 70;
              break;
            }

            root = _this.result.root;

          case 20:
            if (root[isClean]) {
              _context.next = 39;
              break;
            }

            root[isClean] = true;
            stack = [toStack(root)];

          case 23:
            if (!(stack.length > 0)) {
              _context.next = 37;
              break;
            }

            promise = _this.visitTick(stack);

            if (!isPromise(promise)) {
              _context.next = 35;
              break;
            }

            _context.prev = 26;
            _context.next = 29;
            return promise;

          case 29:
            _context.next = 35;
            break;

          case 31:
            _context.prev = 31;
            _context.t1 = _context["catch"](26);
            node = stack[stack.length - 1].node;
            throw _this.handleError(_context.t1, node);

          case 35:
            _context.next = 23;
            break;

          case 37:
            _context.next = 20;
            break;

          case 39:
            if (!_this.listeners.OnceExit) {
              _context.next = 70;
              break;
            }

            _iterator5 = _createForOfIteratorHelper(_this.listeners.OnceExit);
            _context.prev = 41;

            _iterator5.s();

          case 43:
            if ((_step5 = _iterator5.n()).done) {
              _context.next = 62;
              break;
            }

            _step5$value = _slicedToArray(_step5.value, 2), plugin = _step5$value[0], visitor = _step5$value[1];
            _this.result.lastPlugin = plugin;
            _context.prev = 46;

            if (!(root.type === 'document')) {
              _context.next = 53;
              break;
            }

            roots = root.nodes.map(subRoot => visitor(subRoot, _this.helpers));
            _context.next = 51;
            return Promise.all(roots);

          case 51:
            _context.next = 55;
            break;

          case 53:
            _context.next = 55;
            return visitor(root, _this.helpers);

          case 55:
            _context.next = 60;
            break;

          case 57:
            _context.prev = 57;
            _context.t2 = _context["catch"](46);
            throw _this.handleError(_context.t2);

          case 60:
            _context.next = 43;
            break;

          case 62:
            _context.next = 67;
            break;

          case 64:
            _context.prev = 64;
            _context.t3 = _context["catch"](41);

            _iterator5.e(_context.t3);

          case 67:
            _context.prev = 67;

            _iterator5.f();

            return _context.finish(67);

          case 70:
            _this.processed = true;
            return _context.abrupt("return", _this.stringify());

          case 72:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 11], [26, 31], [41, 64, 67, 70], [46, 57]]);
    }))();
  }

  prepareVisitors() {
    this.listeners = {};

    let add = (plugin, type, cb) => {
      if (!this.listeners[type]) this.listeners[type] = [];
      this.listeners[type].push([plugin, cb]);
    };

    var _iterator6 = _createForOfIteratorHelper(this.plugins),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        let plugin = _step6.value;

        if (typeof plugin === 'object') {
          for (let event in plugin) {
            if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
              throw new Error("Unknown event ".concat(event, " in ").concat(plugin.postcssPlugin, ". ") + "Try to update PostCSS (".concat(this.processor.version, " now)."));
            }

            if (!NOT_VISITORS[event]) {
              if (typeof plugin[event] === 'object') {
                for (let filter in plugin[event]) {
                  if (filter === '*') {
                    add(plugin, event, plugin[event][filter]);
                  } else {
                    add(plugin, event + '-' + filter.toLowerCase(), plugin[event][filter]);
                  }
                }
              } else if (typeof plugin[event] === 'function') {
                add(plugin, event, plugin[event]);
              }
            }
          }
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    this.hasListener = Object.keys(this.listeners).length > 0;
  }

  visitTick(stack) {
    let visit = stack[stack.length - 1];
    let node = visit.node,
        visitors = visit.visitors;

    if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
      stack.pop();
      return;
    }

    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
      let _visitors$visit$visit = _slicedToArray(visitors[visit.visitorIndex], 2),
          plugin = _visitors$visit$visit[0],
          visitor = _visitors$visit$visit[1];

      visit.visitorIndex += 1;

      if (visit.visitorIndex === visitors.length) {
        visit.visitors = [];
        visit.visitorIndex = 0;
      }

      this.result.lastPlugin = plugin;

      try {
        return visitor(node.toProxy(), this.helpers);
      } catch (e) {
        throw this.handleError(e, node);
      }
    }

    if (visit.iterator !== 0) {
      let iterator = visit.iterator;
      let child;

      while (child = node.nodes[node.indexes[iterator]]) {
        node.indexes[iterator] += 1;

        if (!child[isClean]) {
          child[isClean] = true;
          stack.push(toStack(child));
          return;
        }
      }

      visit.iterator = 0;
      delete node.indexes[iterator];
    }

    let events = visit.events;

    while (visit.eventIndex < events.length) {
      let event = events[visit.eventIndex];
      visit.eventIndex += 1;

      if (event === CHILDREN) {
        if (node.nodes && node.nodes.length) {
          node[isClean] = true;
          visit.iterator = node.getIterator();
        }

        return;
      } else if (this.listeners[event]) {
        visit.visitors = this.listeners[event];
        return;
      }
    }

    stack.pop();
  }

}

LazyResult.registerPostcss = dependant => {
  postcss = dependant;
};

module.exports = LazyResult;
LazyResult.default = LazyResult;
Root.registerLazyResult(LazyResult);
Document.registerLazyResult(LazyResult);